import { loadingController } from "@ionic/vue";

const showLoading = async (message: string) => {
    const loading = await loadingController.create({
        spinner: 'crescent',
        message: message,
    });

    loading.present();
};

const hideLoading = async () => {
    await loadingController.dismiss();
};

export { showLoading, hideLoading };